<template>
  <div class="machine-group">
    <search-user-machine-group
      v-on:addUserMachineGroup="addUserMachineGroup"
      v-on:onSubmit="onSubmit"
      v-on:resetSearch="resetSearch"
      :search="search"
    >
    </search-user-machine-group>
    <add-user-machine-group
      v-on:cancel="cancel"
      :userMachineGroup="userMachineGroup"
      :dialogUserMachineGroup="dialogUserMachineGroup"
    >
    </add-user-machine-group>
    <move-user-machine-group
      v-on:moveUserMachineGroupCancel="moveUserMachineGroupCancel"
      :teamId="teamId"
      :dialogMoveUserMachineGroup="dialogMoveUserMachineGroup"
    >
    </move-user-machine-group>
    <config-user-machine
      :portSet="portSet"
      :baudSet="baudSet"
      :deviceMode="modeList"
      :dialogConfigMachine="dialogConfigMachine"
      :yesNo="yesNo"
      v-on:cancel="configCancel"
      :userEquipment="configSubmit"
      :biaoshi="1"
      :ageDevice="ageDevice"
      :ageType="ageType"
      :priorityMode="priorityMode"
      :IdcardCountry="IdcardCountry"
      :feelLock="feelLock"
    >
    </config-user-machine>
    <div class="vue-padding">
      <el-table
        v-loading="loading"
        :empty-text="$t('common.noData')"
        :element-loading-text="$t('common.loading')"
        :data="userMachineGroupList"
        style="width: 100%"
        max-height="638"
        :border="true"
      >
        <el-table-column
          prop="nickName"
          :show-overflow-tooltip="true"
          :label="$t('userMachineGroup.nickName')"
          :align="'center'"
        ></el-table-column>
        <el-table-column
          prop="name"
          :label="$t('userMachineGroup.name')"
          :show-overflow-tooltip="true"
          :align="'center'"
        ></el-table-column>
        <el-table-column
          fixed="right"
          :label="$t('common.operate')"
          :width="$i18n.locale == 'en_US' ? 400 : 260"
          :align="'center'"
        >
          <template slot-scope="scope">
            <el-button size="mini" v-hasPerm="['user:machine:group:insert']" @click="editMachineGroup(scope.row)">{{
              $t("common.edit")
            }}</el-button>
            <el-button
              size="mini"
              v-hasPerm="['user:machine:group:move']"
              type="warning"
              @click="transferMachine(scope.row)"
              >{{ $t("userMachineGroup.transfer") }}</el-button
            >
            <!-- COMMENTED OUT: Batch Configuration Button - Not needed in machine group
            <el-button
              type="primary"
              icon="el-icon-s-tools"
              v-hasPerm="['user:equipment:config']"
              size="mini"
              @click="configUserMachine(scope.row)"
              style="padding: 7px"
              >{{ $t("machineConfig.plConfig") }}</el-button
            >
            -->
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="delMachineGroup(scope.row)"
              style="padding: 7px"
              >{{ $t("common.delete") }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="userMachineGroupList.length > 0"
        background
        layout="total,sizes,prev, pager, next,jumper"
        :current-page="page.pageIndex"
        :total="page.totalSize"
        :page-size="page.pageSize"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
  import searchUserMachineGroup from "_c/machine/user/SearchUserMachineGroup";
  import addUserMachineGroup from "_c/machine/user/AddUserMachineGroup";
  import moveUserMachineGroup from "_c/machine/user/MoveUserMachineGroup";
  import configUserMachine from "_c/machine/user/ConfigUserMachine";
  export default {
    name: "MachineGroup",
    components: {
      moveUserMachineGroup,
      addUserMachineGroup,
      configUserMachine,
      searchUserMachineGroup
    },
    data() {
      return {
        search: {
          userName: "",
          name: ""
        },
        page: {
          pageSize: 10,
          pageIndex: 1
        },
        userMachineGroupList: [],
        dialogUserMachineGroup: false,
        userMachineGroup: {
          id: "",
          name: "",
          userEquipmentIds: [],
          maintenances: []
        },
        loading: false,
        dialogMoveUserMachineGroup: false,
        portSet: [],
        baudSet: [],
        modeList: [],
        yesNo: [],
        ageDevice: [],
        ageType: [],
        priorityMode: [],
        dialogConfigMachine: false,
        feelLock: [],
        configSubmit: {
          config: {
            info: {
              isPAd: null,
              isTAd: null,
              isPTag: null,
              isFaultClose: null,
              isCoupon: null,
              isEye: null,
              isPrivacy: null,
              privacy: "",
              isSms: null,
              isFaultLock: null,
              moneySign: "",
              isGoodsMode: null
            },
            manager: {
              isOpen: null,
              isDebug: null,
              passWord: ""
            },

            remote: {
              isBlue: null,
              blueType: null,
              isHaptic: null,
              hapticType: null
            },
            model: {
              type: null,
              lockPage: null,
              isPrompt: null,
              title: "",
              message: "",
              confirm: "",
              cancel: "",
              passWord: "",
              time: []
            },
            vatRate: {
              isOpen: null,
              isCalculating: null,
              type: null,
              proportion: null
            },
            shopping: {
              isTip: null,
              tipTitle: "",
              tipMessage: "",
              tipConfirm: "",
              tipCancel: "",
              isCart: null,
              cartNum: null
            },
            age: {
              isAge: null,
              ageCamera: null,
              ageQrCode: null,
              agePriority: null,
              ageDevice: "",
              isAgeFace: null,
              ageCount: null,
              ageSDK: null,
              faceSimilarity: null,
              isSecurity: null,
              isFace: null,
              time: [],
              ageRange: null
            },
            elock: {
              isOpen: null
            },
            advert: {
              isCountdown: null,
              countdown: ""
            }
          },
          equipmentNo: "",
          id: "",
          verify: [],
          walletPrice: ""
        },
        teamId: "",
        IdcardCountry: []
      };
    },
    mounted() {
      this.currentChange();
      this.getIdcardCountry();
      this.getYesNo();
      this.machineMode();
      this.getPort();
      this.getBaud();
      this.getAgeDevice();
      this.getAgeType();
      this.getPriorityMode();
      this.getFeelLock();
    },
    methods: {
      getFeelLock() {
        this.$api.dict("feel_lock").then(res => {
          if (res.code === 0) {
            this.feelLock = res.data;
          }
        });
      },
      getAgeDevice() {
        this.$api.dict("age_device").then(res => {
          if (res.code === 0) {
            this.ageDevice = res.data;
          }
        });
      },
      getAgeType() {
        this.$api.dict("age_discern_type").then(res => {
          if (res.code === 0) {
            this.ageType = res.data;
          }
        });
      },
      getPriorityMode() {
        this.$api.dict("priority_mode").then(res => {
          if (res.code === 0) {
            this.priorityMode = res.data;
          }
        });
      },
      getIdcardCountry() {
        this.$api.dict("sys_idcard_country").then(res => {
          if (res.code === 0) {
            this.IdcardCountry = res.data;
          }
        });
      },
      configCancel(dialog, state) {
        this.dialogConfigMachine = dialog;
        if (state) {
          this.currentChange();
        }
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
        this.currentChange();
      },
      currentChange(pageIndex) {
        this.loading = true;
        this.page.pageIndex = pageIndex ? pageIndex : 1;
        let obj = this.$cloud.objMerge(this.search, this.page);
        this.$api
          .request(this.$url.UserMachineGroup.page, this.$method.get, obj)
          .then(res => {
            if (res.code === 0) {
              this.userMachineGroupList = res.data.records;
              this.page.totalSize = parseInt(res.data.total);
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      },
      configUserMachine(row) {
        this.configSubmit.id = row.id;
        this.dialogConfigMachine = true;
      },
      machineMode() {
        this.$api.dict("gp_user_machine_mode").then(res => {
          this.modeList = res.data;
        });
      },
      getYesNo() {
        this.$api.dict("sys_yes_no").then(res => {
          if (res.code === 0) {
            this.yesNo = res.data;
          }
        });
      },
      getPort() {
        this.$api.dict("sys_app_type").then(res => {
          if (res.code === 0) {
            this.portSet = res.data;
          }
        });
      },
      getBaud() {
        this.$api.dict("sys_baud_type").then(res => {
          if (res.code === 0) {
            this.baudSet = res.data;
          }
        });
      },
      addUserMachineGroup() {
        this.dialogUserMachineGroup = true;
      },
      resetSearch(data) {
        this.search = data;
        this.currentChange();
      },
      onSubmit(data) {
        this.search = data;
        this.currentChange();
      },
      cancel(dialog, state) {
        this.dialogUserMachineGroup = dialog;
        if (state) {
          this.currentChange(this.page.pageIndex);
        }
      },
      editMachineGroup(row) {
        this.dialogUserMachineGroup = true;
        Object.keys(this.userMachineGroup).forEach(key => {
          this.userMachineGroup[key] = row[key];
        });
        this.userMachineGroup.id = row.id;
      },
      transferMachine(row) {
        this.dialogMoveUserMachineGroup = true;
        this.teamId = row.id;
      },
      moveUserMachineGroupCancel(dialog) {
        this.dialogMoveUserMachineGroup = dialog;
      },
      delMachineGroup(row) {
        let _self = this;
        _self
          .$confirm(_self.$t("grouptransfer.delwarn"), _self.$t("common.warning"), {
            confirmButtonText: _self.$t("common.definite"),
            cancelButtonText: _self.$t("common.cancel"),
            type: "warning"
          })
          .then(() => {
            _self.$api
              .request(_self.$url.UserMachineGroup.delete, _self.$method.delete, {
                id: row.id
              })
              .then(res => {
                if (res.code === 0) {
                  _self.$notify({
                    title: _self.$t("common.tip"),
                    message: res.msg,
                    type: "success"
                  });
                  _self.currentChange();
                }
              });
          });
      }
    }
  };
</script>

<style>
  .el-dialog__header {
    padding: 20px;
  }
  .el-dialog__body {
    padding: 0 20px;
    height: auto !important;
  }
  .el-dialog__footer {
    padding: 20px;
  }
</style>
